export enum PostStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  EXPIRED = 'expired',
  CLOSED = 'closed',
  DELETED = 'deleted',
}

export enum PostRequestStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  CANCELLED = 'cancelled',
  DONE = 'done',
}
